import { computed } from "vue";
import { usePage } from "@inertiajs/vue3";

export declare type Team = any;

export const useTeam = () => {
  const page = usePage();
  const team = computed(() => page.props.team as Team); // 타입 정의 필요
  const canUseTeamFeature = computed(() => team.value?.subscription?.plan?.name === "team");

  return {
    team,
    currentTeam: computed(() => team.value),
    canUseTeamFeature,
  };
};
